
// Export
module.exports =
  {

    // Search scripts
    search:
      {

        // Method-wide scripts
        _init: function ()
        {
          APPLICATION._APPLICATION.load($('#plots'), APPLICATION._PATH_PREFIX + 'master-premise-database/plots?initial=1', 'MasterPremiseDatabase', 'plots')
        }

      },

    // plots scripts
    plots:
      {

        // Method-wide scripts
        _init: function ()
        {
          
          // Process links
          APPLICATION._APPLICATION.processLinks('#plots', 'MasterPremiseDatabase', 'plots')


        }
      }
  }
